@if (display) {
  <div class="{{ class }}">
    <mat-spinner [diameter]="diameter"></mat-spinner>
    <br />
    <h4>{{ messageToDisplay }}</h4>
  </div>
}
